import { STATUS_LEGEND } from './useEffectiveSlots';

export default function CalendarLegend() {
  return (
    <div className="google-card flex flex-wrap items-center gap-x-5 gap-y-2 bg-white dark:bg-[#303134] border border-[#dadce0] dark:border-[#3c4043] px-4 py-2.5">
      <div className="flex items-center gap-1.5">
        <span className="w-2.5 h-2.5 rounded-full border-2 bg-white dark:bg-[#303134] border-[#1a73e8]" />
        <span className="text-xs text-[#5f6368] dark:text-[#9aa0a6]">Today</span>
      </div>
      {STATUS_LEGEND.map(item => (
        <div key={item.key} className="flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: item.dot }} />
          <span className="text-xs text-[#5f6368] dark:text-[#9aa0a6]">{item.label}</span>
        </div>
      ))}
    </div>
  );
}
